import React, { useEffect, useState } from 'react';
import { Button, Card, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import PartnerListTable from '../component/partner/PartnerListTable';
import PartnerCreateModal from '../component/partner/PartnerCreateModal';
import PartnerEditModal from '../component/partner/PartnerEditModal';
import PartnerService from '../service/partner-service/Partner.service';
import {
  Partner as PartnerType,
  CreatePartnerRequest,
} from '../model/Partner.model';

const Partner: React.FC = () => {
  const [partners, setPartners] = useState<PartnerType[]>([]);
  const [loading, setLoading] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [selectedPartner, setSelectedPartner] = useState<PartnerType | null>(
    null
  );

  const fetchPartners = async () => {
    try {
      setLoading(true);
      const data = await PartnerService.getAllPartners();
      setPartners(data);
    } catch (error) {
      message.error('Không thể tải danh sách đối tác');
      console.error('Error fetching partners:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPartners();
  }, []);

  const handleCreate = async (values: CreatePartnerRequest) => {
    try {
      setCreateLoading(true);
      await PartnerService.createPartner(values);
      message.success('Thêm đối tác thành công');
      setCreateModalOpen(false);
      fetchPartners();
    } catch (error) {
      message.error('Không thể thêm đối tác');
      console.error('Error creating partner:', error);
    } finally {
      setCreateLoading(false);
    }
  };

  const handleEdit = async (id: number, values: CreatePartnerRequest) => {
    try {
      setEditLoading(true);
      await PartnerService.updatePartner(id, values);
      message.success('Cập nhật đối tác thành công');
      setEditModalOpen(false);
      setSelectedPartner(null);
      fetchPartners();
    } catch (error) {
      message.error('Không thể cập nhật đối tác');
      console.error('Error updating partner:', error);
    } finally {
      setEditLoading(false);
    }
  };

  const handleDelete = async (id: number) => {
    try {
      setLoading(true);
      await PartnerService.deletePartner(id);
      message.success('Xóa đối tác thành công');
      fetchPartners();
    } catch (error) {
      message.error('Không thể xóa đối tác');
      console.error('Error deleting partner:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditClick = (partner: PartnerType) => {
    setSelectedPartner(partner);
    setEditModalOpen(true);
  };

  return (
    <div className="p-6">
      <Card
        title="Quản lý đối tác"
        extra={
          <Button
            type="default"
            icon={<PlusOutlined />}
            onClick={() => setCreateModalOpen(true)}
            color="blue"
            variant="filled"
          >
            Thêm đối tác
          </Button>
        }
      >
        <PartnerListTable
          partners={partners}
          loading={loading}
          onEdit={handleEditClick}
          onDelete={handleDelete}
        />
      </Card>

      <PartnerCreateModal
        open={createModalOpen}
        loading={createLoading}
        onOk={handleCreate}
        onCancel={() => setCreateModalOpen(false)}
      />

      <PartnerEditModal
        open={editModalOpen}
        loading={editLoading}
        partner={selectedPartner}
        onOk={handleEdit}
        onCancel={() => {
          setEditModalOpen(false);
          setSelectedPartner(null);
        }}
      />
    </div>
  );
};

export default Partner;
